import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { VerifyReCaptchaParams, verifyReCaptchaToken } from '../utils/backend-api/recaptcha';
import { SuccessResponse } from '../utils/interfaces';

export default function useVerifyReCaptcha() {
  const { mutate, mutateAsync } = useMutation(
    (params: VerifyReCaptchaParams) => verifyReCaptchaToken(params),
    {
      onSuccess: ({ success }: SuccessResponse) => {
        if (!success) {
          toast.error('Something went wrong. Please try again.');
        }
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );

  return { mutate, mutateAsync };
}
